import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserService } from "../../../shared/services/user.service";

import { DataService_visitordesign } from "./shared/data.service";

import { wsClickOnceDeployInfo } from "./shared/wsClickOnceDeployInfo";

@Component({
	selector: "app-root",
	templateUrl: "./visitordesign.component.html",
	styleUrls: ["./visitordesign.component.css"],
})
export class VisitorDesignComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_visitordesign, private userService: UserService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;

	//	Printers List
	public lstClickOnceDeploy: wsClickOnceDeployInfo[] = [];

	public CAASSVisitorIDDeployUrl: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.isBusy = true;
		this.dataService.ClickOnceDeployURLSelect().subscribe((data) => this.ClickOnceDeployURLSelect_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ClickOnceDeployURLSelect_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ClickOnceDeployURLSelect_Complete(data: any) {
		this.lstClickOnceDeploy = data;

		if (this.lstClickOnceDeploy.length == 1) {
			this.CAASSVisitorIDDeployUrl = this.lstClickOnceDeploy[0].CAASSVisitorIDDeploy;
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCAASSVisitorIDDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onCAASSVisitorIDDeploy() {
		window.open(this.CAASSVisitorIDDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
